import { render, staticRenderFns } from "./pay_balance.vue?vue&type=template&id=2c156e08&scoped=true"
import script from "./pay_balance.vue?vue&type=script&lang=js"
export * from "./pay_balance.vue?vue&type=script&lang=js"
import style0 from "./pay_balance.vue?vue&type=style&index=0&id=2c156e08&prod&lang=scss&scoped=true"
import style1 from "./pay_balance.vue?vue&type=style&index=1&id=2c156e08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c156e08",
  null
  
)

export default component.exports